import React from 'react';
import {ShortReservation} from '@guestapp/sdk';
import ChekinPro from '../ChekinPro';

type UseReservationFetchListenerProps = {
  status: 'loading' | 'error' | 'success';
  reservation?: ShortReservation;
};
function useReservationFetchListener({
  status,
  reservation,
}: UseReservationFetchListenerProps) {
  React.useEffect(() => {
    if (status === 'success' || status === 'error') {
      const isSuccessfullyFound = Boolean(status === 'success' && reservation?.id);
      if (isSuccessfullyFound) {
        ChekinPro.events.onReservationFound();
      }

      ChekinPro.events.onReservationFetched({isSuccess: isSuccessfullyFound});
    }
  }, [reservation?.id, status]);
}

export {useReservationFetchListener};
